<template>
  <img :class="classstr" :loadimg1="resourcepath + '/images/' + src" />
</template>
<script>
import { mapState} from "vuex";
import {
  iskong,
  resourcepath,
} from "../commonjs/commonfn.js";
export default {
  name: "yuimg1",
  props: ["delay", "durtime", "src", "isActiveT", "effect", "loadimg1index"],
  data() {
    return {
      resourcepath: resourcepath,
      classtrs: "",
      loadimg1str: 11,
    };
  },

  mounted() {},
  methods: {},

  computed: {
    delay1() {
      if (!iskong(this.effect)) {
        let attr = this.delay.toString().split(".");
        if (parseInt(attr[1]) == 0) {
          return attr[0];
        } else {
          return attr[0] + "D" + attr[1];
        }
      } else {
        return 0;
      }
    },
    durtime1() {
      if (!iskong(this.effect)) {
        let attr = this.durtime.toString().split(".");

        return attr[0] + "D" + attr[1];
      } else {
        return 0;
      }
    },
    classstr() {
      var classtrs = "";
      if (!iskong(this.effect)) {
        var animjson = {};
        animjson["animated"] = this.isActiveT;
        animjson[this.effect] = this.isActiveT;
        animjson["vable"] = this.isActiveT;
        classtrs = [
          "vhidden  animdur" +
            this.durtime1 +
            " animdelay" +
            this.delay1 +
            "  loadimg1",
          animjson,
        ];
      } else {
        classtrs = "loadimg1";
      }
      return classtrs;
    },
    ...mapState(["isalljiazai", "isActive", "loadimg1attr"]),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/yuimg1.vue